<div class="disable-full-screen" [style.opacity]="modal.is_active ? 100 : 0" [style.visibility]="modal.is_active ? 'visible' : 'hidden'">
  <div class="background" [@background] (click)="closeModal()"></div>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="container-center" *ngIf="!isLoading">
    <div class="modal dealer-plan-for-standard-modal">
      <div class="items-area" style="border-radius: 5px; border-bottom: 0; overflow-x: hidden">
        <div class="modal-title">Upgrade today to access our most popular features</div>
        <div style="min-height: 24px;">
          <div class="close"><i class="material-icons" (click)="closeModal()">close</i></div>
          <div class="flex" style="margin: 28px 0 20px 0; gap: 24px">
            <div class="feature-bar" (click)="onClickChangeFeature('cloud-ai')">
              <div class="flex v-center"><i [ngClass]="computedIconStyleClass('cloud-ai')">auto_awesome</i>
                <div>Cloud based AI Filtering</div>
              </div>
              <div class="clicked-box" *ngIf="clickedFeature === 'cloud-ai'"></div>
            </div>
            <div class="feature-bar" (click)="onClickChangeFeature('automation-rule')">
              <div class="flex v-center"><i [ngClass]="computedIconStyleClass('automation-rule')">auto_awesome</i>
                <div>Automation Rules</div>
              </div>
              <div class="clicked-box" *ngIf="clickedFeature === 'automation-rule'"></div>
            </div>
            <div class="feature-bar" (click)="onClickChangeFeature('new-feature')">
              <div class="flex v-center"><i [ngClass]="computedIconStyleClass('new-feature')">auto_awesome</i>
                <div>New Features</div>
              </div>
              <div class="clicked-box" *ngIf="clickedFeature === 'new-feature'"></div>
            </div>
            <div class="feature-bar" (click)="onClickChangeFeature('other-feature')">
              <div class="flex v-center"><i [ngClass]="computedIconStyleClass('other-feature')">auto_awesome</i>
                <div>Coming soon...</div>
              </div>
              <div class="clicked-box" *ngIf="clickedFeature === 'other-feature'"></div>
            </div>
          </div>
          <div class="carousal-container" [class.hidden]="clickedFeature === 'new-feature'">
            <div id="carousal-slide">
              <div class="carousal-slide-el flex v-center" style="padding: 24px; width: 100%; position: relative;">
                <div class="video-loader" *ngIf="isLoadingVideo">
                  <div class="loader absolute">
                    <svg class="circular" viewBox="25 25 50 50">
                      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
                    </svg>
                  </div>
                </div><img class="carousal-slide-el" src="/assets/imgs/cloud-ai-persuade.png" style="max-width: 310px; position: absolute; left: 58px; top: 58px;"/>
                <div class="flex" id="cloud-ai" style="position: absolute; right: 118px; top: 16px">
                  <iframe (load)="videoUploadDone()" width="310" height="200" [src]="cloudAIDescriptionVideo[cloudAIDescriptionVideoRegion] | safe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                </div>
              </div>
              <div class="carousal-slide-el flex v-center" style="padding: 24px; width: 100%; justify-content: center; gap: 10px">
                <div class="video-loader" *ngIf="isLoadingVideo"></div><img src="/assets/imgs/persuade-automation-rule.png" style="max-width: 310px;"/>
                <div class="flex" id="automation-rule">
                  <iframe (load)="videoUploadDone()" width="310" height="200" [src]="automationRuleDescriptionVideo[automationRuleDescriptionVideoRegion] | safe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                </div>
              </div>
              <div class="carousal-slide-el" style="min-width: 700px"></div>
              <div class="carousal-slide-el flex v-center" style="padding: 24px; width: 100%; justify-content: center"><img class="carousal-slide-el" src="/assets/imgs/video-suvilliance.png" style="max-width: 300px;"/></div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="feature-description">
            <div id="description-carousal-container">
              <div id="description-carousal-slide">
                <div class="description-carousal-slide-el"><b>CHeKT's AI filtering </b> <span style="color: #55647B">provides a second layer of filtering on video alarm events. AI filtering ensures a Human and Vehicle is detected in a defined area of interest before transmitting an alarm signal, increasing operator efficiency and improving customer confidence in your video monitoring service.</span><br/><br/>
                  <div class="cloud-ai-description">
                    🎉 <b>Cost Savings</b>: Reduction in false alarm and monitoring costs created by nuisance alarms.<br/>
                    🛠️ <b>Enhance Traditional Sensors</b>: Define area detection and object classification on traditional sensors like PIR and Photobeams.<br/>
                    💡 <b>Improve Edge Analytics</b>: Filter false alarms created by cameras with poor analytic analysis.<br/>
                    📌 <b>Increased Operational Efficiently</b>: Allow operators to focus on true alarm activity.<br/>
                  </div>
                </div>
                <div class="description-carousal-slide-el">
                  <b>Automation rules </b> <span style="color: #55647B">allow you to automate audio broadcasts, IP lighting, video recording, onboard relays, and more based on an alarm condition, day and time rules, and armed status.</span><br/><br/>
                  <span style="color: #55647B">Unlock the power of your CHeKT Visual Security system with Automation Rules and transform your service offerings.</span>
                </div>
                <div class="description-carousal-slide-el">
                  <div class="flex column" style="gap: 24px">
                    <div>
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">🎥 Extend video retention</div>
                      <div style="color: #55647B">Extend video events from 30 days to 90 or 1 year on the Professional and Premium plans, respectively.</div>
                    </div>
                    <div> 
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">💫 CHeKT Cloud API</div>
                      <div style="color: #55647B">Open integration to 3rd party software systems and automate CheKT functions using cloud-based API options.</div>
                    </div>
                    <div>
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">🌐 Local Bridge APIs</div>
                      <div style="color: #55647B">Unlock local Bridge hardware API’s for integration with onsite AI platforms and other solutions.</div>
                    </div>
                    <div>
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">🔈 Audio Messaging Services</div>
                      <div style="color: #55647B">
                        Audio broadcast service allows the monitoring station and customer mobile app to initiate preloaded messages or live voice talk-down.<br/><br/>
                        Site Automation Rules can automatically play preloaded audio messages.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="description-carousal-slide-el">
                  <div class="flex column" style="gap: 24px">
                    <div>
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">👮‍♀️ Video Guard Tour</div>
                      <div style="color: #55647B">CheKT will empower you and your command center with the capabilities of a virtual security guard. Record video feeds from onsite cameras and send them to command center operators at set times. Then allow operators to conduct a live video tour of the site and review the recorded video captured between tours.</div>
                    </div>
                    <div>
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">📞 Two Way Audio Services</div>
                      <div style="color: #55647B">Two Way service can provide real-time, contextual alerts to the site.</div>
                    </div>
                    <div>
                      <div style="font-weight: bold; color: rgba(0, 0, 0, 0.87)">🗂️ Branch Grouping</div>
                      <div style="color: #55647B">Branch Grouping enables CHeKT dealers to organize sites by branches for streamlined workflow and managed installer access. Users and installers can access sites relevant to their branches while ensuring separation and restriction from accessing other sites and branches.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="upgrade-button-area">
            <mat-checkbox style="color:hsla(0,0%,0%,0.87); font-size: 14px" [(ngModel)]="isHiding" [labelPosition]="'after'">Don't Show Again</mat-checkbox>
            <div class="cancel-button" (click)="closeModal()">Maybe Later</div>
            <div class="upgrade-button" (click)="onClickUpgrade()">Upgrade Now</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>